exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".alerts-wrapper{position:fixed;top:50px;left:0;right:0;z-index:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/AlertsWrapper.scss
// module id = 126
// module chunks = 0